import * as React from "react";

import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { EstadosECidades } from "src/util/estados-cidades";
import { Select, Row, Col } from "antd";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import ISpouse from "src/services/interfaces/ISpouse";
import { PbrInputDate } from "../../PbrInputDate/PbrInputDate";
import { SelectIssuingAuthority } from '../../SelectIssuingAuthority/SelectIssuingAuthority';

interface IRGProps extends FormComponentProps {
  trade: ITrade;
  onChange: (value: Partial<ITradeOwner> | Partial<ISpouse>) => void;
  isOwnerRG: boolean;
  isRGrequired: boolean;
  isRGDateRequired: boolean;
  isIssuingAuthorityRequired: boolean;
}

export const EditRG: React.FC<IRGProps> = ({
  trade,
  onChange,
  isOwnerRG,
  form,
  isRGrequired,
  isRGDateRequired,
  isIssuingAuthorityRequired
}) => {
  return (
    <>
      <Row gutter={30}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name={`rg_${isOwnerRG ? "owner" : "spouse"}`}
            title="RG"
            formWrapper={form}
            formItemProps={{ label: "RG" }}
            placeholder="Digite o RG"
            value={isOwnerRG ? trade.tradeOwner?.rg : trade.tradeOwner.spouse?.rg}
            onChange={e => onChange({ rg: e.target.value })}
            rules={[
              {
                required: isRGrequired,
                message: "Informe o RG"
              }
            ]}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrSelect
            name={`rgState_${isOwnerRG ? "owner" : "spouse"}`}
            size="large"
            formItemProps={{ label: "Estado do RG" }}
            showSearch
            value={isOwnerRG ? trade.tradeOwner?.rgState : trade.tradeOwner.spouse?.rgState}
            onChange={e => onChange({ rgState: e.toString() })}
            placeholder="Estado do RG"
            formWrapper={form}
            rules={[
              {
                required: isRGrequired,
                message: "Informe o estado do RG"
              }
            ]}
          >
            <Select.Option key={"none"} value="">
              Selecione o estado do RG
            </Select.Option>
            {EstadosECidades.map((e, i) => (
              <Select.Option key={i.toString()} value={e.uf}>{`${e.nome}`}</Select.Option>
            ))}
          </PbrSelect>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputDate
            name={`rgExpeditionDate_${isOwnerRG ? "owner" : "spouse"}`}
            formWrapper={form}
            formItemProps={{ label: "Data da expedição do RG" }}
            placeholder={"Informe a Resposta"}
            isRequired={isRGDateRequired}
            requiredMessage="Data da expedição do RG obrigatório"
            value={isOwnerRG ? trade.tradeOwner?.rgExpeditionDate : trade.tradeOwner.spouse?.rgExpeditionDate}
            onChange={e => onChange({ rgExpeditionDate: e })}
            rules={[{ required: isRGDateRequired, message: "Data da expedição do RG obrigatório" }]} />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <SelectIssuingAuthority
            name={`rgIssuingAuthority_${isOwnerRG ? "owner" : "spouse"}`}
            nameIssuingAuthority={isOwnerRG ? trade.tradeOwner?.rgIssuingAuthority : trade.tradeOwner.spouse?.rgIssuingAuthority}
            onChange={e => onChange({ rgIssuingAuthority: e.toString() })}
            form={form}
            isIssuingrequired={isIssuingAuthorityRequired}
          />
        </Col>
      </Row>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditRG/EditRG.tsx